import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import TopNav from "./TopNav";
import SideNav from "./SideNav";
import ScopeBanner from "./ScopeBanner";
import AuditorBanner from "./AuditorBanner";
import BackButton from "./BackButton";
import RequestAssistanceFab from "@/components/assistance/RequestAssistanceFab";
import AskIsoquestAI from "@/components/ai/AskIsoquestAI";
import { getTenantScope } from "@/lib/api";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dark, setDark] = useState(false);
  const [scopeActive, setScopeActive] = useState(!!getTenantScope());

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
  }, [dark]);

  useEffect(() => {
    const scope = getTenantScope();
    const onChange = () => setScopeActive(!!getTenantScope());
    // Also update banner offset for auditor scope
    setScopeActive(!!scope);
    window.addEventListener("isoquest:scope-changed", onChange);
    return () => window.removeEventListener("isoquest:scope-changed", onChange);
  }, []);

  return (
    <div className="min-h-screen text-slate-900 dark:text-slate-100">
      <TopNav
        onToggleSidebar={() => setMobileOpen(true)}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        collapsed={collapsed}
        dark={dark}
        onToggleTheme={() => setDark((d) => !d)}
      />
      <ScopeBanner />
      <AuditorBanner />
      <div className={`flex ${scopeActive ? "pt-[104px]" : "pt-16"}`}>
        <SideNav
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />
        <main
          data-testid="app-main"
          className={`flex-1 min-w-0 transition-[margin] duration-300 ease-out ${
            collapsed ? "md:ml-20" : "md:ml-64"
          }`}
        >
          <BackButton />
          <Outlet />
        </main>
      </div>
      <RequestAssistanceFab />
      <AskIsoquestAI />
    </div>
  );
}
